module.exports = require('./helpers/bundle-url').getBundleURL('5FFt5') + "logo-dark.ba5147f0.svg";